import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";

import { RequestMethod } from "@/shared/utils/RequestMethod";

export const routinesApi = api
  .enhanceEndpoints({
    addTagTypes: ["routines"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      routines: builder.query({
        query: ({ trainingPlanId, position, name, group }) => ({
          url: `routines`,
          method: RequestMethod.GET,
          params: camelToSnake({
            trainingPlanId,
            position,
            name,
            group,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["routines"],
      }),
    }),
  });

export const { useRoutinesQuery } = routinesApi;
